import React, { useState } from 'react';

const SimpleCalculator = () => {
  const [expr, setExpr] = useState('0');

  const handleBtn = (value) => {
    if (value === '=') {
      try {
        // eslint-disable-next-line no-eval
        const result = eval(expr);
        setExpr(Number.isFinite(result) ? String(result) : '0');
      } catch {
        setExpr('0');
      }
    } else {
      const next = expr === '0' && value !== '.' ? value : expr + value;
      setExpr(next);
    }
  };

  return (
    <div className="simple-calc">
      <h3>🧮 Calculator</h3>
      <div className="calc-screen" id="calcScreen">
        {expr}
      </div>
      <div className="calc-grid">
        {['7', '8', '9', '/', '4', '5', '6', '*', '1', '2', '3', '-', '0', '.', '=', '+'].map((key) => (
          <button
            key={key}
            type="button"
            className={`calc-btn ${key === '=' ? 'btn-equal' : ''}`}
            onClick={() => handleBtn(key)}
          >
            {key}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SimpleCalculator;
